export const TOTAL = 'Total';

export const TRACKER_BUCKETS = {
  NATIONAL_SCOPE: 'nationalScope',
};
